import React, { Fragment } from 'react'
import { Field } from 'redux-form/immutable'
import moment from 'moment'

import SectionHeader from 'app/components/SectionHeader'
import Input from 'app/components/Input'
import TextArea from 'app/components/TextArea'
import DateRangeField from 'app/components/DateRangeField'
import Button from 'app/components/ButtonDefault'
import Gallery from 'app/domains/common/Gallery'
import { badgeImageProps } from 'app/constants/imageInputs'
import { MICROACTIONS_PATH } from 'app/constants/navLinks.js'
import LinkButton from 'app/domains/common/LinkButton'
import Loader from 'app/components/Loaders/FormLoader'
import { required, number, maxLength } from 'helpers/validators'
import { SPRINT_BADGE, GALLERY_S3_ENTITY } from 'app/constants/gallery'

import './styles.scss'
const bc = 'organization-sprint'

const isRequired = required()
const maxLength100 = maxLength(100)
const maxLength200 = maxLength(200)

const OrganizationSprintForm = ({
  handleSubmit,
  t,
  pristine,
  invalid,
  match: { params: { organizationId, sprintId } },
  startDate,
  isPendingSprint,
}) => {
  if (isPendingSprint) {
    return <Loader />
  }
  const started = moment().diff(moment(startDate), 'hours') >= 0

  return (
    <Fragment>
      <SectionHeader title={t('Configurate Sprint')} backHref />
      <form onSubmit={handleSubmit} className={`${bc}__wrapper`}>
        <div className={`${bc}__left`}>
          <Field
            name="title"
            component={Input}
            label={t('Sprint Title')}
            placeholder={t('Sprint Title')}
            validate={[isRequired, maxLength100]}
          />
          <Field
            name="dates"
            component={DateRangeField}
            className={`${bc}__dates`}
            startDatePlaceholderText={t('Begin Date')}
            endDatePlaceholderText={t('End Date')}
            styles={{ marginBottom: '16px' }}
            validate={[isRequired]}
          />
          <div className={`${bc}__goals`}>
            <div className={`${bc}__goal`}>
              <Field
                name="userGoal"
                component={Input}
                label={t('Personal Goal')}
                placeholder={20}
                validate={[isRequired, number]}
                disabled={started && sprintId}
              />
              <div className={`${bc}__goal-actions`}>{t('common:Actions')}</div>
            </div>
            <div className={`${bc}__goal`}>
              <Field
                name="organizationGoal"
                component={Input}
                label={t('Organization Goal')}
                placeholder={1000}
                validate={[isRequired, number]}
                disabled={started && sprintId}
              />
              <div className={`${bc}__goal-actions`}>{t('common:Actions')}</div>
            </div>
          </div>
          <Field
            name="firstDayMessage"
            component={TextArea}
            label={t('1st Day Message')}
            placeholder={t('common:Message')}
            maxCharacters={200}
            validate={[isRequired, maxLength200]}
          />
          <Field
            name="beforeEndMessage"
            component={TextArea}
            label={t('Day 2 Until End Message')}
            placeholder={t('common:Message')}
            maxCharacters={200}
            validate={[isRequired, maxLength200]}
          />
          <Field
            name="afterEndMessage"
            component={TextArea}
            label={t('Day after Sprint Message')}
            placeholder={t('common:Message')}
            maxCharacters={200}
            validate={[isRequired, maxLength200]}
          />
        </div>
        <div className={`${bc}__right`}>
          <div>
            <Field
              name="badge"
              component={Gallery}
              imageInputProps={badgeImageProps}
              minImageWidth={badgeImageProps.minSize.width}
              minImageHeight={badgeImageProps.minSize.height}
              innerModifier={SPRINT_BADGE}
              s3Entity={GALLERY_S3_ENTITY[SPRINT_BADGE]}
              validate={[isRequired]}
            />
            <Field
              name="badgeTitle"
              component={Input}
              label={t('Badge Title')}
              placeholder={t('Badge Title')}
              validate={[isRequired, maxLength100]}
            />
          </div>
          <div>
            <Field
              name="orgGoalAchievedMessage"
              component={TextArea}
              label={t('Day after Sprint Message (if Organization hits goal)')}
              placeholder={t('common:Message')}
              maxCharacters={200}
              validate={[isRequired, maxLength200]}
            />
            <Field
              name="userGoalAchievedMessage"
              component={TextArea}
              label={t('Day after Sprint Message (if Personal Goal achieved)')}
              placeholder={t('common:Message')}
              maxCharacters={200}
              validate={[isRequired, maxLength200]}
            />
          </div>
        </div>
      </form>
      <div className={`${bc}__buttons`}>
        <Button primary xs onClick={() => handleSubmit()} disabled={pristine || invalid}>
          {t('common:Save')}
        </Button>
        <LinkButton to={`${MICROACTIONS_PATH}/organizations/${organizationId}/edit`}>{t('common:Cancel')}</LinkButton>
      </div>
    </Fragment>
  )
}

export default OrganizationSprintForm
